import React from "react";
import { connect } from "react-redux";
import SocialActionClicksCard from "visual-components/analytics/campaign/SocialActionClicksCard";

/**
 * Social Action Clicks Container Component
 * Connects to Redux and passes data to the presentation component
 * @param {Object} props
 * @param {Object} props.data - Social action clicks data from Redux
 * @param {boolean} props.started - Whether the campaign has started
 * @returns {import("react").ReactElement}
 */
function SocialActionClicks(props) {
  const { data, started } = props;

  return <SocialActionClicksCard data={data} started={started} />;
}

const mapStateToProps = (state) => {
  return {
    data: state.analyticsCampaign.campaignSocialActionClicksByTitle.data || [],
  };
};

export default connect(mapStateToProps)(SocialActionClicks);
